import { Link } from '@remix-run/react'
import { ContactRound } from 'lucide-react'
import { Button } from './button'

const AnonymousMemberCta = () => (
	<div className="flex">
		<div className="relative rounded-lg border bg-orange-100 p-4 text-xl shadow-md">
			Become an <span className="font-bold">intuizen</span> member today!
			<br />
			<Button asChild className="group mt-4 transition-colors">
				<Link to="/signup">
					{' '}
					<ContactRound className="mr-2" />
					Register your{' '}
					<span className="mx-1 border-b-2 border-orange-200 font-bold text-orange-300 group-hover:text-orange-500">
						FREE
					</span>{' '}
					Account
				</Link>
			</Button>
		</div>
	</div>
)

export default AnonymousMemberCta
